export default {
  'step3.firstChoice': 'My company is registered',
  'step3.secondChoice': 'My company is in the process of being created',
  'step3.noRadio': 'Please choose the status of your company',
};
